var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-header',{class:{
      'pt-5': _vm.$laravel.user.is_owner_contact || _vm.$laravel.user.owner_id,
    },attrs:{"fluid":"","breadcrumbs":false}},[_c('h1',{staticClass:"title is-4"},[_c('d-previous-btn',{attrs:{"path":'/owners/' + _vm.model.id + '/owner-businesses'}}),_vm._v("\n      "+_vm._s(_vm.$t("new_owner_business"))+"\n    ")],1)]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"create","owner_id":_vm.model.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }